import styled from 'styled-components';
import {
  WholePageContainer,
} from '../Grid';

const headerHeight = 3.75; // in rem
const footerBottomMargin = 1; // in rem
const footerHeight = 8; // in arem

const gridLines = {
  pageTop: 'country-profiles-landing-page-top',
  headerTop: 'country-profiles-landing-header-top',
  headerBottom: 'country-profiles-landing-header-bottom',
  contentTop: 'country-profiles-landing-content-top',
  startButtonTop: 'country-profiles-landing-start-button-top',
  contentBottom: 'country-profiles-landing-content-bottom',
  footerTop: 'country-profiles-landing-footer-top',
  footerBottom: 'country-profiles-landing-footer-bottom',
  pageBottom: 'country-profiles-landing-page-bottom',
};

export const Grid = styled(WholePageContainer)`
  display: grid;
  grid-template-rows:
    [${gridLines.pageTop} ${gridLines.headerTop}] ${headerHeight}rem
    [${gridLines.headerBottom} ${gridLines.contentTop}] auto
    [${gridLines.startButtonTop}] auto
    [${gridLines.contentBottom} ${gridLines.footerTop}] ${footerHeight}rem
    [${gridLines.footerBottom}] ${footerBottomMargin}rem
    [${gridLines.pageBottom}];
  grid-template-columns: 2fr 1fr 1fr;
  grid-column-gap: 2rem;
  height: 100vh;

  @media (max-width: 800px) {
    grid-template-columns: 2fr 1fr 0;
  }
`;

export const ContentBackgroundContainer = styled.div`
  grid-row: ${gridLines.pageTop} / ${gridLines.pageBottom};
  grid-column: 1 / 4;
`;

export const HeaderContainer = styled.div`
  grid-row: ${gridLines.headerTop} / ${gridLines.headerBottom};
  grid-column: 1 / 4;
`;
export const HeaderBackgroundContainer = styled.div`
  grid-row: ${gridLines.headerTop} / ${gridLines.headerBottom};
  grid-column: 1 / 4;
`;
export const LeftPanelContainer = styled.div`
  grid-row: ${gridLines.contentTop} / ${gridLines.startButtonTop};
  grid-column: 1 / 2;
`;
export const StartButtonContainer = styled.div`
  grid-row: ${gridLines.startButtonTop} / ${gridLines.contentBottom};
  grid-column: 1 / 2;
`;

export const LefFooterContainer = styled.div`
  grid-row: ${gridLines.contentBottom} / ${gridLines.footerBottom};
  grid-column: 1 / 2;
`;

export const RightFooterContainer = styled.div`
  grid-row: ${gridLines.contentBottom} / ${gridLines.footerBottom};
  grid-column: 2 / 4;
`;

export const WidgetsContainer = styled.div`
  grid-row: ${gridLines.contentTop} / ${gridLines.contentBottom};
  grid-column: 2 / 3;
`;

export const MapConainer = styled.div`
  grid-row: ${gridLines.contentTop} / ${gridLines.contentBottom};
  grid-column: 3 / 4;
`;
